/**
 * @generated SignedSource<<bd3dddbef99e7ee509e9605d9ba71ec4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ContentSystemTaskKind = "add_events_to_calendar" | "calendar_connection" | "community_agreement" | "complete_profile" | "connect_slack" | "custom_profile_field" | "default_profile_fields" | "download_mobile_app" | "onboarding_complete" | "onboarding_module" | "onboarding_welcome" | "slack_connection" | "slack_invite" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type EditMemberOnboardingContextFragment$data = {
  readonly children: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly content: {
          readonly publishedProfileFields: {
            readonly __id: string;
            readonly totalCount: number;
          } | null;
          readonly systemTaskKind: ContentSystemTaskKind | null;
        };
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"AdminMemberOnboardingListItemFragment" | "EditMemberOnboardingDrawerHeaderFragment" | "EditMemberOnboardingFormFragment" | "EditMemberOnboardingStepSwitcherFragment">;
      };
    }>;
  } | null;
  readonly id: string;
  readonly organization: {
    readonly hasSlackConnection: boolean | null;
    readonly organizationMembershipSlackConnections: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly isPrimary: boolean;
        };
      }>;
    };
    readonly profileFields: {
      readonly totalCount: number;
    };
  };
  readonly " $fragmentType": "EditMemberOnboardingContextFragment";
};
export type EditMemberOnboardingContextFragment$key = {
  readonly " $data"?: EditMemberOnboardingContextFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"EditMemberOnboardingContextFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EditMemberOnboardingContextFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Organization",
      "kind": "LinkedField",
      "name": "organization",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "version",
              "value": 2
            }
          ],
          "kind": "ScalarField",
          "name": "hasSlackConnection",
          "storageKey": "hasSlackConnection(version:2)"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "OrganizationMembershipSlackConnectionNodeConnection",
          "kind": "LinkedField",
          "name": "organizationMembershipSlackConnections",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "OrganizationMembershipSlackConnectionNodeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "OrganizationMembershipSlackConnection",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isPrimary",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "isDefault",
              "value": false
            },
            {
              "kind": "Literal",
              "name": "status",
              "value": "visible"
            }
          ],
          "concreteType": "ProfileFieldNodeConnection",
          "kind": "LinkedField",
          "name": "profileFields",
          "plural": false,
          "selections": [
            (v1/*: any*/)
          ],
          "storageKey": "profileFields(isDefault:false,status:\"visible\")"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "includeDraft",
          "value": true
        }
      ],
      "concreteType": "ContentUsageNodeConnection",
      "kind": "LinkedField",
      "name": "children",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ContentUsageNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ContentUsage",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Content",
                  "kind": "LinkedField",
                  "name": "content",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "systemTaskKind",
                      "storageKey": null
                    },
                    {
                      "alias": "publishedProfileFields",
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "includeDraft",
                          "value": false
                        }
                      ],
                      "concreteType": "ContentUsageNodeConnection",
                      "kind": "LinkedField",
                      "name": "children",
                      "plural": false,
                      "selections": [
                        (v1/*: any*/),
                        {
                          "kind": "ClientExtension",
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "__id",
                              "storageKey": null
                            }
                          ]
                        }
                      ],
                      "storageKey": "children(includeDraft:false)"
                    }
                  ],
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "AdminMemberOnboardingListItemFragment"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "EditMemberOnboardingDrawerHeaderFragment"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "EditMemberOnboardingStepSwitcherFragment"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "EditMemberOnboardingFormFragment"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "children(includeDraft:true)"
    }
  ],
  "type": "Content",
  "abstractKey": null
};
})();

(node as any).hash = "b2b1338c6afe6597891266bacbd7c406";

export default node;
